import type { Meta, StoryFn } from '@storybook/react';

import { QuickCreate, type QuickCreateProps } from '@pega/cosmos-react-wss';

export default {
  title: 'Web Self Service/QuickCreate',
  component: QuickCreate
} as Meta;

interface QuickCreateDemoArgs {
  heading?: QuickCreateProps['heading'];
  count?: number;
  showIcons?: boolean;
}

export const QuickCreateDemo: StoryFn<QuickCreateDemoArgs> = (args: QuickCreateDemoArgs) => {
  const count = args.count || 4;

  const lorem =
    'Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut nesciunt excepturi sit alias, mollitia voluptate nobis, aliquam corrupti delectus ea molestiae, illum provident necessitatibus? Atque temporibus officiis voluptas nam nihil!';

  const actions = Array.from({ length: count }, (_, i) => {
    return {
      label: i === count - 1 ? `${lorem}` : `Case type ${i + 1}`,
      onClick: () => {},
      icon: args.showIcons ? 'case' : undefined
    };
  });
  return <QuickCreate heading={args.heading || 'Quick actions'} actions={actions} />;
};

QuickCreateDemo.args = {
  heading: 'Quick actions',
  count: 4,
  showIcons: true
};

QuickCreateDemo.argTypes = {
  heading: { control: { type: 'text' } },
  count: { control: { type: 'number' } },
  showIcons: { control: { type: 'boolean' } }
};
